<template>
  <div>
    <table-header
      :key="$route.query.search || 'all'"
      :filters="filteringOptions"
      :secondFilters="secondFilteringOptions"
      :thirdFilters="payments_types"
      :title="`Płatności`"
      :titleExtraInfo="`${
        this.$route.query.search &&
        this.payments.data &&
        this.payments.data.list &&
        this.payments.data.list.length >= 1 &&
        this.payments.data.list[0].user_wallet.amount
          ? `Stan portfela użytkownika: ${this.payments.data.list[0].user_wallet.amount}zł`
          : ''
      }`"
      :withPagination="true"
      :withFilters="true"
      :withSecondFilters="true"
      :withThirdFilters="true"
      :dispatchAction="'getAllPayments'"
      :onPage="this.payments.data.on_page"
      :pageNumber="this.payments.data.page_number"
      :total="this.payments.data.total"
      :downloadAction="true"
      :refreshAction="true"
      :tableName="'payments'"
      :thirdFiltersLabel="'Rodzaj płatności'"
      :firstAdditionalButton="
        this.$route.query.search
          ? `Doładowanie konta dla numeru ${this.$route.query.search}`
          : null
      "
      :secondAdditionalButton="
        this.$route.query.search
          ? `Doładowanie bonusowe dla numeru ${this.$route.query.search}`
          : null
      "
      :thirdAdditionalButton="
        this.$route.query.search
          ? `Opłata serwisowa dla numeru ${this.$route.query.search}`
          : null
      "
      @firstMethodToListen="addMoneyToWalletWithAccountingNote()"
      @secondMethodToListen="addMoneyToWalletWithoutAccountingNote()"
      @thirdMethodToListen="penaltyForUser()"
    >
      <template #extra-content v-if="paymentCards && paymentCards.length > 0">
        <div class="payment-card" style="border: none">
          <img
            src="@/icons/green-payment-card.svg"
            alt="payment card"
            data-toggle="modal"
            :data-target="`#userPaymentsCards`"
          />
        </div>
      </template>
    </table-header>
    <button
      id="addToWalletButton"
      type="button"
      class="btn btn-outline-dark tableButton navy-button"
      data-toggle="modal"
      style="visibility: hidden"
      :data-target="`#addToWallet`"
      @click="setUserId()"
    ></button>
    <button
      id="addToWalletPromotionButton"
      type="button"
      class="btn btn-outline-dark tableButton navy-button"
      style="visibility: hidden"
      data-toggle="modal"
      :data-target="`#addToWalletPromotion`"
      @click="setUserId()"
    ></button>
    <button
      id="penaltyForUser"
      type="button"
      class="btn btn-outline-dark tableButton navy-button"
      data-toggle="modal"
      style="visibility: hidden"
      :data-target="`#penaltyForUserModal`"
      @click="setUserId()"
    ></button>

    <loader v-if="isLoadingPayments" />

    <table
      class="table table-striped table-sm"
      v-else-if="this.payments && this.payments.data.total > 0"
    >
      <thead>
        <tr class="tr-table">
          <th scope="col">Data utworzenia płatności</th>
          <th scope="col">
            {{
              paymentsType !== "payments_users"
                ? "SessionID"
                : "Rodzaj płatności"
            }}
          </th>
          <th scope="col">ID płatności</th>
          <th scope="col">ID użytkownika</th>
          <th scope="col">Imię</th>
          <th scope="col">Nazwisko</th>
          <th scope="col">Numer telefonu</th>
          <th scope="col">Numer konta</th>
          <th scope="col">Czy konto zweryfikowane?</th>
          <th scope="col">Kwota w portfelu</th>
          <th scope="col">
            {{ paymentsType !== "payments_users" ? "Kwota płatności" : "Typ" }}
          </th>
          <th scope="col">
            {{ paymentsType !== "payments_users" ? "Typ" : "Kwota płatności" }}
          </th>
          <th scope="col">Status</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="payment in this.payments.data.list"
          :key="payment.payment_id"
        >
          <td v-if="payment.creationDate">
            {{
              payment.creationDate ? formattedDate(payment.creationDate) : ""
            }}
          </td>
          <td v-else>
            {{
              payment.creation_date ? formattedDate(payment.creation_date) : ""
            }}
          </td>
          <td>{{ payment.session_id ? payment.session_id : "Brak" }}</td>
          <td>{{ payment.payment_id ? payment.payment_id : "Brak" }}</td>
          <!-- USER -->
          <td v-if="payment.user">
            {{ payment.user.id ? payment.user.id : "" }}
          </td>

          <td v-if="payment.user">
            {{ payment.user.first_name ? payment.user.first_name : "" }}
          </td>
          <td v-if="payment.user">
            {{ payment.user.last_name ? payment.user.last_name : "" }}
          </td>
          <td v-if="payment.user">
            {{ payment.user.phone ? payment.user.phone : "" }}
          </td>

          <td v-if="payment.paying_user">
            {{ payment.paying_user.id ? payment.paying_user.id : "" }}
          </td>
          <td v-if="payment.paying_user">
            {{
              payment.paying_user.first_name
                ? payment.paying_user.first_name
                : ""
            }}
          </td>
          <td v-if="payment.paying_user">
            {{
              payment.paying_user.last_name ? payment.paying_user.last_name : ""
            }}
          </td>
          <td v-if="payment.paying_user">
            {{ payment.paying_user.phone ? payment.paying_user.phone : "" }}
          </td>

          <td>
            {{
              payment.user_wallet && payment.user_wallet.account_number
                ? payment.user_wallet.account_number
                : " Brak"
            }}
          </td>
          <td>
            {{
              payment.user_wallet && payment.user_wallet.account_verified
                ? `Tak`
                : `Nie`
            }}
          </td>
          <td>
            <div class="walletButtons">
              {{
                payment.amount_in_wallet !== null
                  ? payment.amount_in_wallet
                  : payment.user_wallet && payment.user_wallet.amount !== null
                  ? payment.user_wallet.amount
                  : 0
              }}

              <button
                v-if="userRole === 'ADMIN1' || userRole === 'ADMIN'"
                type="button"
                class="btn btn-outline-dark tableButton navy-button"
                data-toggle="modal"
                :data-target="`#addToWallet`"
                @click="setUserId(payment.user.phone)"
              >
                Doładuj
              </button>
              <button
                v-if="payment.user_wallet.amount"
                type="button"
                class="btn btn-outline-dark"
                data-toggle="modal"
                :data-target="`#addWithdrawRequest`"
                @click="
                  setDataToWithdraw(
                    payment.user.id,
                    payment.user_wallet.account_number
                  )
                "
              >
                Wypłać
              </button>
            </div>
          </td>
          <template v-if="paymentsType !== 'payments_users'">
            <td
              class="fontGreen"
              v-if="
                payment.payment_type === 'INCOME_PAYMENT' ||
                payment.payment_type === 'VERIFICATION_RETURN' ||
                payment.payment_type === 'ORDER_EMPLOYEE' ||
                payment.payment_type === 'ORDER_CUSTOMER_RETURN' ||
                payment.payment_type === 'ORDER_EMPLOYEE' ||
                payment.payment_type === 'WALLET'
              "
            >
              {{ payment.price ? payment.price : "" }}
            </td>
            <td
              class="fontRed"
              v-if="
                payment.payment_type === 'WITHDRAW' ||
                payment.payment_type === 'VERIFICATION' ||
                payment.payment_type === 'ORDER_CUSTOMER' ||
                payment.payment_type === 'PENALTY' ||
                payment.payment_type === 'ORDER' ||
                payment.payment_type === 'COMMISSION'
              "
            >
              {{ payment.price ? payment.price : "" }}
            </td>
            <td>
              <span class="fontGreen">
                {{
                  payment.payment_type &&
                  (payment.payment_type === "INCOME_PAYMENT" ||
                    payment.payment_type === "WALLET")
                    ? payment.promotionalIncome && payment.topUpType != null
                      ? translateTopUpType(payment.topUpType)
                      : "Doładowanie"
                    : ""
                }}
              </span>
              <span class="fontRed">
                {{
                  payment.payment_type &&
                  payment.payment_type === "VERIFICATION"
                    ? "Weryfikacja-"
                    : ""
                }}
              </span>
              <span class="fontGreen">
                {{
                  payment.payment_type &&
                  payment.payment_type === "VERIFICATION_RETURN"
                    ? "Weryfikacja+"
                    : ""
                }}
              </span>
              <span class="fontGreen">
                {{
                  payment.payment_type &&
                  payment.payment_type === "ORDER_EMPLOYEE"
                    ? "Wpływ"
                    : ""
                }}
              </span>
              <span class="fontRed">
                {{
                  payment.payment_type && payment.payment_type === "WITHDRAW"
                    ? "Wypłata"
                    : ""
                }}
              </span>

              <span class="fontGreen">
                {{
                  payment.payment_type &&
                  payment.payment_type === "ORDER_CUSTOMER_RETURN"
                    ? "Zwrot"
                    : ""
                }}
              </span>
              <span class="fontRed">
                {{
                  payment.payment_type &&
                  (payment.payment_type === "ORDER_CUSTOMER" ||
                    payment.payment_type === "ORDER")
                    ? "Płatność"
                    : ""
                }}
              </span>
              <span class="fontRed">
                {{
                  payment.payment_type && payment.payment_type === "PENALTY"
                    ? payment.promotionalOutcome
                      ? "Zwrot doładowania promocyjnego z kodu zniżkowego"
                      : "Opłata serwisowa"
                    : ""
                }}
              </span>
              <span class="fontRed">
                {{
                  payment.payment_type && payment.payment_type === "COMMISSION"
                    ? "Prowizja"
                    : ""
                }}
              </span>
            </td>
          </template>
          <template v-else>
            <template v-if="payment.payment_display_name">
              <td
                :class="
                  payment.payment_display_name.type === 'OUTCOME'
                    ? 'fontRed'
                    : 'fontGreen'
                "
              >
                {{
                  payment.payment_display_name.name === "Doładowanie" &&
                  payment.gateway_id &&
                  (payment.gateway_id === 1503 || payment.gateway_id === 1500)
                    ? "Doładowanie kartą BM"
                    : payment.payment_display_name.name === "Doładowanie"
                    ? "Doładowanie przelewem BM"
                    : payment.payment_display_name.name
                }}
              </td>
              <td
                :class="
                  payment.payment_display_name.type === 'OUTCOME'
                    ? 'fontRed'
                    : 'fontGreen'
                "
              >
                {{
                  payment.payment_display_name.type === "OUTCOME" ? "-" : "+"
                }}
                {{ payment.price }}
              </td>
            </template>
            <template v-else>
              <td
                class="fontGreen"
                v-if="
                  payment.payment_type === 'INCOME_PAYMENT' ||
                  payment.payment_type === 'VERIFICATION_RETURN' ||
                  payment.payment_type === 'ORDER_EMPLOYEE' ||
                  payment.payment_type === 'ORDER_CUSTOMER_RETURN' ||
                  payment.payment_type === 'ORDER_EMPLOYEE' ||
                  payment.payment_type === 'WALLET'
                "
              >
                {{ payment.price ? payment.price : "" }}
              </td>
              <td
                class="fontRed"
                v-if="
                  payment.payment_type === 'WITHDRAW' ||
                  payment.payment_type === 'VERIFICATION' ||
                  payment.payment_type === 'ORDER_CUSTOMER' ||
                  payment.payment_type === 'PENALTY' ||
                  payment.payment_type === 'ORDER' ||
                  payment.payment_type === 'COMMISSION'
                "
              >
                {{ payment.price ? payment.price : "" }}
              </td>
              <td>
                <span class="fontGreen">
                  {{
                    payment.payment_type &&
                    (payment.payment_type === "INCOME_PAYMENT" ||
                      payment.payment_type === "WALLET")
                      ? payment.promotionalIncome && payment.topUpType != null
                        ? translateTopUpType(payment.topUpType)
                        : "Doładowanie"
                      : ""
                  }}
                </span>
                <span class="fontRed">
                  {{
                    payment.payment_type &&
                    payment.payment_type === "VERIFICATION"
                      ? "Weryfikacja-"
                      : ""
                  }}
                </span>
                <span class="fontGreen">
                  {{
                    payment.payment_type &&
                    payment.payment_type === "VERIFICATION_RETURN"
                      ? "Weryfikacja+"
                      : ""
                  }}
                </span>
                <span class="fontGreen">
                  {{
                    payment.payment_type &&
                    payment.payment_type === "ORDER_EMPLOYEE"
                      ? "Wpływ"
                      : ""
                  }}
                </span>
                <span class="fontRed">
                  {{
                    payment.payment_type && payment.payment_type === "WITHDRAW"
                      ? "Wypłata"
                      : ""
                  }}
                </span>

                <span class="fontGreen">
                  {{
                    payment.payment_type &&
                    payment.payment_type === "ORDER_CUSTOMER_RETURN"
                      ? "Zwrot"
                      : ""
                  }}
                </span>
                <span class="fontRed">
                  {{
                    payment.payment_type &&
                    (payment.payment_type === "ORDER_CUSTOMER" ||
                      payment.payment_type === "ORDER")
                      ? "Płatność"
                      : ""
                  }}
                </span>
                <span class="fontRed">
                  {{
                    payment.payment_type && payment.payment_type === "PENALTY"
                      ? payment.promotionalOutcome
                        ? "Zwrot doładowania promocyjnego z kodu zniżkowego"
                        : "Opłata serwisowa"
                      : ""
                  }}
                </span>
                <span class="fontRed">
                  {{
                    payment.payment_type &&
                    payment.payment_type === "COMMISSION"
                      ? "Prowizja"
                      : ""
                  }}
                </span>
              </td>
            </template>
          </template>
          <td>{{ payment.payment_state ? payment.payment_state : "" }}</td>
        </tr>

        <div
          class="modal fade"
          :id="`addWithdrawRequest`"
          tabindex="-1"
          role="dialog"
          aria-labelledby="addWithdrawRequest"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl modal-xl" role="dialog">
            <div class="modal-content services-modal">
              <div class="modal-header">
                <h5 class="modal-title" id="addWithdrawRequest">
                  Wysłanie prośby o wypłatę
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form
                  @submit.prevent="handleWithdrawRequest()"
                  class="addToWalletForm"
                >
                  <label>Kwota do wypłaty</label>
                  <input
                    type="number"
                    class="form-control"
                    step="0.01"
                    v-model="amountWithdraw"
                  />
                  <button type="submit" class="btn btn-outline-dark">
                    Wyślij prośbę o wypłatę
                  </button>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-dismiss="modal"
                >
                  Zamknij
                </button>
              </div>
            </div>
          </div>
        </div>
      </tbody>
    </table>

    <div
      class="modal fade"
      id="userPaymentsCards"
      tabindex="-1"
      role="dialog"
      aria-labelledby="userPaymentsCards"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-xl" role="dialog">
        <div class="modal-content services-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="userPaymentsCards">
              Karty użytkownika
            </h5>
            <button
              id="closeUserPaymentsCars"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table style="width: 100%">
              <thead>
                <tr class="tr-table w-100">
                  <th class="w-1/2" scope="col">Numer karty</th>
                  <th class="w-1/2" scope="col">Data dodania</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="card in paymentCards" :key="card.id">
                  <td>
                    {{ `*****${card.lastDigitsOfCardNumber}` }}
                  </td>
                  <td>{{ formattedDateAsNumbers(card.creationDate) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addToWallet"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addToWallet"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-xl" role="dialog">
        <div class="modal-content services-modal">
          <div class="modal-header">
            <h5 class="modal-title" id="addToWalletTitle">
              Doładowanie portfela
            </h5>
            <button
              id="closeAddToWalletModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="handleAddToWallet()"
              class="addToWalletForm"
            >
              <label>Kwota doładowania</label>
              <input
                type="number"
                step="0.01"
                class="form-control"
                v-model="amountToAdd"
              />
              <button
                type="submit"
                class="btn btn-outline-dark"
                :disabled="loading"
              >
                Doładuj portfel
              </button>
            </form>
            <large-amount-confirm
              :visible="largeAmountConfirmVisible"
              :amount="amountToAdd"
              @confirmed="confirmLargeAmount"
              @cancel="largeAmountConfirmVisible = false"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <top-up-modal
      v-if="selectedTopUpOrPenaltyModal === 'TOP_UP'"
      @top-up-done="refreshPayments"
    />

    <penalty-payment-modal
      v-if="selectedTopUpOrPenaltyModal === 'PENALTY'"
      @penalty-done="refreshPayments"
    />
  </div>
</template>

<script>
import TableHeader from "../components/TableHeader.vue";
import shared from "../shared";
import axios from "../axios";
import TopUpModal from "../components/TopUpModal.vue";
import PenaltyPaymentModal from "../components/PenaltyPaymentModal.vue";
import Loader from "../components/Loader.vue";
import LargeAmountConfirm from "../components/LargeAmountConfirm.vue";
import { requiresAmountConfirmation } from "../utils/largeAmount";
export default {
  name: "PaymentsList",
  components: {
    TableHeader,
    TopUpModal,
    PenaltyPaymentModal,
    Loader,
    LargeAmountConfirm,
  },
  computed: {
    payments() {
      return this.$store.getters.getAllPayments;
    },
    searchParams() {
      return this.$store.getters.getSearchParameter;
    },
    userRole() {
      return this.$store.getters.getUserRole;
    },
    sortingParam() {
      return this.$store.getters.getSortingParameter;
    },
    sortingType() {
      return this.$store.getters.getSortingType;
    },
    searchParam() {
      return this.$store.getters.getSearchParameter;
    },
    filterParam() {
      return this.$store.getters.getFilterParameter;
    },
    secondFilterParam() {
      return this.$store.getters.getSecondFilterParameter;
    },
    userByPhone() {
      return this.$store.getters.getSelectedUser;
    },
  },
  created() {
    this.formattedDate = shared.formattedDate;
    this.formattedDateAsNumbers = shared.formattedDateAsNumbers;
    this.loadPaymentsForSearchedUser();
  },
  destroyed() {
    this.$store.dispatch("setPaymentsToNull");
    this.$store.dispatch("clearAllPayments");
  },
  watch: {
    paymentsType: function () {
      this.selectedPaymentType = "all";
      this.handleFilters();
    },
    searchParam: async function (phone) {
      this.$store.commit("SET_USER_BY_PHONE", null);
      if (phone && phone.length === 9) {
        await this.$store.dispatch("getUserByPhone", {
          phone: this.searchParams,
        });
      }
    },

    "$route.query.search": function () {
      this.loadPaymentsForSearchedUser();
    },

    payments: async function (userPayments) {
      this.handleFilters();
      const firstPayment =
        userPayments &&
        userPayments.data &&
        userPayments.data.list &&
        userPayments.data.list[0];
      if (!firstPayment || !firstPayment.user) {
        this.paymentCards = [];
        return;
      }
      const response = await axios.get(
        `api/admin/users/${firstPayment.user.id}/paymentCards`
      );
      if (response && response.data) {
        this.paymentCards = response.data;
      }
    },
  },
  methods: {
    async loadPaymentsForSearchedUser() {
      this.$store.dispatch("clearAllPayments");
      this.paymentCards = [];
      this.isLoadingPayments = true;
      this.$store.dispatch("fetchUserByPhoneOrUserId", {
        param: this.$route.query.search,
        withoutPush: true,
      });
      try {
        await this.$store.dispatch("getAllPayments", {
          on_page: this.payments.pagination.on_page,
          page_number: this.payments.pagination.page_number,
          search_param: this.$route.query.search,
        });
      } finally {
        this.isLoadingPayments = false;
      }
    },

    async refreshPayments() {
      await this.$store.dispatch("getAllPayments", {
        on_page: this.payments.pagination.on_page,
        page_number: this.payments.pagination.page_number,
        filter_param: this.filterParam,
        search_param: this.$route.query.search,
        second_filter_param: this.secondFilterParam,
        custom_search_param: this.customSearchParam,
        second_custom_search_param: this.secondCustomSearchParam,
      });
    },

    translateTopUpType(type) {
      if (type === "ACCOUNT") {
        return "Doładowanie konta";
      }
      if (type === "BONUS") {
        return "Doładowanie bonusowe";
      }
      if (type === "DISCOUNT") {
        return "Doładowanie promocyjne z kodu zniżkowego";
      }
    },
    addMoneyToWalletWithAccountingNote() {
      document.getElementById("addToWalletButton").click();
    },
    addMoneyToWalletWithoutAccountingNote() {
      this.selectedTopUpOrPenaltyModal = "TOP_UP";
      setTimeout(() => {
        document.getElementById("addToWalletPromotionButton").click();
      }, 200);
    },
    penaltyForUser() {
      this.selectedTopUpOrPenaltyModal = "PENALTY";
      setTimeout(() => {
        document.getElementById("penaltyForUser").click();
      }, 200);
    },
    handleFilters() {
      if (this.$el.querySelector("#secondFilterSelect")) {
        this.paymentsType = this.$el.querySelector("#secondFilterSelect").value;
      }
      if (
        this.paymentsType === null ||
        this.selectedPaymentType === "all" ||
        this.paymentsType === "payments_users" ||
        this.paymentsType === ""
      ) {
        this.payments_types = [
          {
            name: "",
            displayName: "Wszystkie",
          },
          {
            name: "ORDER_CUSTOMER",
            displayName: "Płatność",
          },
          {
            name: "ORDER_CUSTOMER_RETURN",
            displayName: "Zwrot",
          },
          {
            name: "ORDER_EMPLOYEE",
            displayName: "Wpływ",
          },
          {
            name: "WITHDRAW",
            displayName: "Wypłata",
          },
          {
            name: "INCOME_PAYMENT",
            displayName: "Doładowanie",
          },
          {
            name: "VERIFICATION_RETURN",
            displayName: "Weryfikacja+",
          },
          {
            name: "VERIFICATION",
            displayName: "Weryfikacja-",
          },
          {
            name: "PENALTY",
            displayName: "Opłata serwisowa",
          },
        ];
      }
      if (this.paymentsType === "payments_p24") {
        this.payments_types = [
          {
            name: "",
            displayName: "Wszystkie",
          },
          {
            name: "ORDER",
            displayName: "Płatność",
          },
          {
            name: "WALLET",
            displayName: "Doładowanie",
          },
          {
            name: "VERIFICATION",
            displayName: "Weryfikacja+",
          },
          {
            name: "VERIFICATION_RETURN",
            displayName: "Weryfikacja-",
          },
        ];
      }
      if (this.paymentsType === "payments_admin") {
        this.payments_types = [
          {
            name: "",
            displayName: "Wszystkie",
          },
          {
            name: "PENALTY",
            displayName: "Opłata serwisowa",
          },
          {
            name: "COMMISSION",
            displayName: "Prowizja",
          },
        ];
      }

      if (this.paymentsType === "from_admin") {
        this.payments_types = null;
      }
    },

    async setUserId(id) {
      if (!id) {
        if (this.userByPhone) {
          this.userId = this.userByPhone.phone;
        }
      } else {
        this.userId = id;
      }
    },
    setDataToWithdraw(userId, accountNumber) {
      (this.userId = userId), (this.accountNumberToWithdraw = accountNumber);
    },

    handleWithdrawRequest() {
      const url = `/api/withdraw/add/${this.userId}?value=${this.amountWithdraw}`;
      axios
        .post(url)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie wysłano prośbę o wypłatę środków dla tego użytkownika",
            });
            this.refreshPayments();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAddToWallet() {
      if (requiresAmountConfirmation(this.amountToAdd)) {
        this.largeAmountConfirmVisible = true;
        return;
      }
      this.addToWallet();
    },
    confirmLargeAmount() {
      this.largeAmountConfirmVisible = false;
      this.addToWallet();
    },
    addToWallet() {
      this.loading = true;
      let phone;
      if (this.userId) {
        phone = this.userId;
      } else {
        phone = this.$route.query.search;
      }

      const url = `/api/payment/wallet/income`;
      const data = {
        amount: this.amountToAdd,
        withoutAccountingNote: true,
        phoneNumber: phone,
      };

      axios
        .post(url, data)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano kwotę do portfela użytkownika",
            });
            document.getElementById("closeAddToWalletModal").click();
            this.refreshPayments();
            setTimeout(() => {
              this.loading = false;
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        });
    },
  },

  data() {
    return {
      selectedTopUpOrPenaltyModal: "TOP_UP",
      userId: "",
      user_phone: "",
      list_type: "payments_users",
      filter_param: "",
      amountToAdd: "",
      largeAmountConfirmVisible: false,
      accountNumberToWithdraw: "",
      selectedPaymentType: "all",
      amountWithdraw: "",
      paymentsType: null,
      payment_types_options: [],
      loading: false,
      isLoadingPayments: true,
      filteringOptions: [
        {
          name: "",
          displayName: "Wszystkie",
        },
        {
          name: "CREATED",
          displayName: "Utworzone",
        },
        {
          name: "FINISHED",
          displayName: "Zakończone",
        },
        {
          name: "REJECTED",
          displayName: "Odrzucone",
        },
      ],
      secondFilteringOptions: [
        {
          name: "payments_users",
          displayName: "Payments Users",
        },
        {
          name: "payments_p24",
          displayName: "Payments BlueMedia",
        },
        {
          name: "payments_admin",
          displayName: "Payments Admin",
        },
        {
          name: "from_admin",
          displayName: "Dodane przez admina",
        },
      ],
      payments_types: null,
      paymentCards: [],
    };
  },
};
</script>

<style scoped>
.addToWalletForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.addToWalletForm input,
.addToWalletForm button {
  width: 200px;
}
.walletButtons {
  display: flex;
  flex-direction: column;
}
.fontRed {
  color: red;
  font-weight: bold;
}
.fontGreen {
  color: green;
  font-weight: bold;
}
.payment-card {
  display: flex;
  align-items: center;
  cursor: pointer;
}
</style>
